var map = {
	"./americano.svg": "81f5",
	"./americano_old.svg": "05c8",
	"./ar.svg": "9cda",
	"./de.svg": "93c2",
	"./en.svg": "7534",
	"./es.svg": "b45f",
	"./fr.svg": "95e0",
	"./gr.svg": "283b",
	"./it.svg": "b468",
	"./ja.svg": "7677",
	"./pt.svg": "a673",
	"./ru.svg": "fc3f",
	"./zh.svg": "b677"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6053";